
(function(modal) {
    

publishingApp.directive('modal', ['$document', '$window', '$compile', function($document, $window, $compile) {
    return {
        restrict: 'A',
        scope: true,
        link: function (scope, element, attrs) {

            element.bind('click', function (event) {

                if (event.target.className === 'btn-modal'){
                    $(event.target.nextElementSibling).show();
                }
                if (event.target.className === 'close'){
                    $('.modal').hide();
                }
            });

        }
    }
}]);
}('modal'));

